import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Name of employee:", -1);
const _hoisted_3 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_4 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Current Stage:", -1);
const _hoisted_6 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_7 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Current Assignee:", -1);
const _hoisted_9 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_10 = { class: "py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Status:", -1);
const _hoisted_12 = { class: "mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" };
const _hoisted_13 = {
    key: 0,
    class: "flex justify-end"
};
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("b", null, "*Please ensure that all mandatory fields are completed before\n          submitting for approval", -1);
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("b", null, "*For compatible browsers please review this link. If your browser is\n          not compatible it may effect the text you see within multi line text\n          boxes and /or the speed of the people search.", -1);
const _hoisted_17 = { key: 0 };
const _hoisted_18 = { key: 4 };
const _hoisted_19 = {
    key: 7,
    class: "mt-4 text-left border border-gray-200 rounded-md bg-white p-3"
};
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("h4", { class: "text-sm font-medium text-gray-900" }, "Letters sent", -1);
const _hoisted_21 = { class: "mt-2 space-y-3" };
const _hoisted_22 = { class: "flex items-start justify-between gap-2" };
const _hoisted_23 = { class: "font-medium" };
const _hoisted_24 = { class: "text-gray-500" };
const _hoisted_25 = {
    key: 0,
    class: "text-red-600"
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = {
    key: 12,
    class: "italic text-gray-800 mt-2"
};
const _hoisted_28 = { class: "rounded-lg p-4 w-full" };
const _hoisted_29 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("label", {
    for: "comments",
    class: "block text-sm font-medium text-gray-700"
}, "Rejection Comments", -1);
const _hoisted_31 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_activity_feed = _resolveComponent("activity-feed");
    const _component_approval_steps = _resolveComponent("approval-steps");
    const _component_form_layout = _resolveComponent("form-layout");
    const _component_ExclamationIcon = _resolveComponent("ExclamationIcon");
    const _component_ModalWindow = _resolveComponent("ModalWindow");
    const _component_CheckIcon = _resolveComponent("CheckIcon");
    const _component_MailIcon = _resolveComponent("MailIcon");
    const _component_SendAmendLetterUpload = _resolveComponent("SendAmendLetterUpload");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_form_layout, {
            "nav-item-config": _ctx.navItems,
            "current-nav-item": _ctx.currentNavItem,
            "form-point": _ctx.formPoint,
            "form-data": _ctx.amendsFormData,
            "display-header": _ctx.disableForm || _ctx.editable,
            "display-timeline": _ctx.disableForm || _ctx.editable,
            "display-footer": _ctx.disableForm || _ctx.editable,
            "print-mode": _ctx.inPrintMode,
            "form-name": "amendForm",
            onSetCurrentNavItem: _ctx.setCurrentNavItem
        }, {
            pageTitle: _withCtx(() => [
                _createTextVNode("Employee Amends")
            ]),
            header: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createTextVNode(),
                    _createElementVNode("dd", _hoisted_3, _toDisplayString(_ctx.amendsFormData?.formOne?.name || '-'), 1)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createTextVNode(),
                    _createElementVNode("dd", _hoisted_6, _toDisplayString(_ctx.currentStage?.displayName || "-"), 1)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createTextVNode(),
                    _createElementVNode("dd", _hoisted_9, _toDisplayString(_ctx.amendsFormData?.currentAssigneeEmail || '-'), 1)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createTextVNode(),
                    _createElementVNode("dd", _hoisted_12, _toDisplayString(_ctx.amendsFormData?.status || '-'), 1)
                ]),
                _createTextVNode(),
                (_ctx.profile?.ADMIN || _ctx.profile?.H2R || _ctx.profile?.RESOURCING)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto",
                            onClick: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => (_ctx.handleReassign && _ctx.handleReassign(...args)))
                        }, "\n            Re-assign\n          ")
                    ]))
                    : _createCommentVNode("", true)
            ]),
            pageSubtitle: _withCtx(() => [
                _hoisted_14,
                _hoisted_15,
                _createTextVNode(),
                _hoisted_16
            ]),
            main: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentNavItem?.component), {
                    "form-data": _ctx.amendsFormData[_ctx.currentNavItem?.name],
                    data: _ctx.amendsFormData,
                    "disable-form": _ctx.disableForm,
                    "config-items": _ctx.configItems,
                    "can-complete": _ctx.canComplete,
                    onSubmitForm: _ctx.handleSubmitForm,
                    onCompleteAmend: _ctx.handleCompleteAmend,
                    "onUpdate:formData": _ctx.handleUpdateFormData
                }, null, 40, ["form-data", "data", "disable-form", "config-items", "can-complete", "onSubmitForm", "onCompleteAmend", "onUpdate:formData"]))
            ]),
            printArea: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItemConfig, (comp) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: comp.name
                    }, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(comp?.component), {
                            "form-data": _ctx.amendsFormData[comp?.name],
                            data: _ctx.amendsFormData,
                            "disable-form": true,
                            "config-items": _ctx.configItems,
                            "can-complete": _ctx.canComplete
                        }, null, 8, ["form-data", "data", "config-items", "can-complete"]))
                    ]));
                }), 128))
            ]),
            navFooter: _withCtx(() => [
                (_ctx.currentUserIsDirectlyAssigned &&
                    (_ctx.disableForm || _ctx.editable) &&
                    _ctx.amendsFormData?.currentStageName === 'amend.notifyBudgetApprover')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        (!_ctx.editable)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: _normalizeClass(["w-full text-center px-4 py-2 mb-2 rounded-md text-white bg-blue-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat", { 'bg-red-700 border-red-900': _ctx.editable }]),
                                onClick: _cache[1] || (_cache[1] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleMakeEditable && _ctx.handleMakeEditable(...args)))
                            }, "\n            Edit\n          ", 2))
                            : _createCommentVNode("", true),
                        _createTextVNode(),
                        _createElementVNode("button", {
                            class: "w-full text-center px-4 py-2 rounded-md text-white bg-green-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                            onClick: _cache[2] || (_cache[2] =
                                //@ts-ignore
                                (...args) => (_ctx.handleApprove && _ctx.handleApprove(...args)))
                        }, _toDisplayString(_ctx.editable ? "Save Edits" : "Approve"), 1)
                    ]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.amendsFormData?.currentStageName === 'DRAFT')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "w-full mt-2 text-center px-4 py-2 rounded-md text-white bg-red-700 hover:bg-red-800 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.showDeleteModal = true))
                    }, "\n          Delete Draft\n        "))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.currentUserIsAssigned &&
                    _ctx.disableForm &&
                    _ctx.amendsFormData?.currentStageName === 'amend.notifyAmendH2R')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "w-full text-center px-4 py-2 rounded-md text-white bg-green-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[4] || (_cache[4] =
                            //@ts-ignore
                            (...args) => (_ctx.handleAssignAdmin && _ctx.handleAssignAdmin(...args)))
                    }, "\n          Assign Admin\n        "))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.canPrint)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        class: "w-full text-center mt-2 px-4 py-2 rounded-md text-white bg-blue-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[5] || (_cache[5] =
                            //@ts-ignore
                            (...args) => (_ctx.print && _ctx.print(...args)))
                    }, "\n          Print/Save to PDF\n        "))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.currentUserIsDirectlyAssigned &&
                    (_ctx.disableForm || _ctx.editable) &&
                    _ctx.amendsFormData?.currentStageName === 'amend.notifyHROps')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        (!_ctx.editable)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: _normalizeClass(["w-full text-center px-4 py-2 mb-2 rounded-md text-white bg-blue-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat", { 'bg-red-700 border-red-900': _ctx.editable }]),
                                onClick: _cache[6] || (_cache[6] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleMakeEditable && _ctx.handleMakeEditable(...args)))
                            }, "\n            Edit\n          ", 2))
                            : _createCommentVNode("", true),
                        _createTextVNode(),
                        _createElementVNode("button", {
                            class: "w-full text-center px-4 py-2 rounded-md text-white bg-green-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                            onClick: _cache[7] || (_cache[7] =
                                //@ts-ignore
                                (...args) => (_ctx.handleApprove && _ctx.handleApprove(...args)))
                        }, _toDisplayString(_ctx.editable ? "Save Edits" : "Approve Second line"), 1)
                    ]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.currentUserIsAssigned &&
                    _ctx.amendsFormData?.currentStageName ===
                        'amend.notifyAmendH2RAdminUpdated')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 5,
                        class: "w-full text-center px-4 py-2 rounded-md text-white bg-green-700 hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[8] || (_cache[8] =
                            //@ts-ignore
                            (...args) => (_ctx.handleConfirmAmend && _ctx.handleConfirmAmend(...args)))
                    }, "\n          Admin Approve Or More Info\n        "))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.canSendAmendLetter)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 6,
                        class: "w-full text-center mt-2 px-4 py-2 rounded-md text-white bg-green-700 hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[9] || (_cache[9] = ($event) => (_ctx.showSendAmendLetterModal = true))
                    }, "\n          Send letter\n        "))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.amendLettersList.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _hoisted_20,
                        _createTextVNode(),
                        _createElementVNode("ul", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.amendLettersList, (letter) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: letter.sendId,
                                    class: "text-sm text-gray-700 border-t border-gray-100 pt-2 first:border-0 first:pt-0"
                                }, [
                                    _createElementVNode("div", _hoisted_22, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("p", null, [
                                                _createElementVNode("span", _hoisted_23, _toDisplayString(letter.status), 1),
                                                _createTextVNode("\n                    · " + _toDisplayString(letter.recipientEmail), 1)
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("p", _hoisted_24, "\n                    Sent by " + _toDisplayString(letter.requestedByEmail) + "\n                    ·\n                    " + _toDisplayString(_ctx.formatAmendLetterDate(letter.sentAt || letter.requestedAt)), 1),
                                            _createTextVNode(),
                                            (letter.status === 'FAILED' && letter.failureReason)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(letter.failureReason), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "shrink-0 text-blue-700 hover:underline",
                                            onClick: ($event) => (_ctx.downloadAmendLetter(letter))
                                        }, "\n                  Download\n                ", 8, _hoisted_26)
                                    ])
                                ]));
                            }), 128))
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.currentUserIsDirectlyAssigned &&
                    _ctx.amendsFormData?.currentStageName === 'amend.notifyHMMoreInfo')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 8,
                        class: "w-full text-center px-4 py-2 rounded-md text-white bg-green-700 hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[10] || (_cache[10] =
                            //@ts-ignore
                            (...args) => (_ctx.handleRespondMoreInfo && _ctx.handleRespondMoreInfo(...args)))
                    }, "\n          Reply to more info request\n        "))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.currentUserIsAssigned &&
                    _ctx.disableForm &&
                    _ctx.amendsFormData?.currentStageName === 'amend.notifyH2RUpdateAmend')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 9,
                        class: "w-full text-center px-4 py-2 rounded-md text-white bg-green-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[11] || (_cache[11] =
                            //@ts-ignore
                            (...args) => (_ctx.handleCompleteRequest && _ctx.handleCompleteRequest(...args)))
                    }, "\n          Complete request\n        "))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.amendsFormData?.currentStageName &&
                    _ctx.amendsFormData?.currentStageName !== 'DRAFT' &&
                    (_ctx.profile?.ADMIN ||
                        _ctx.profile?.H2R ||
                        _ctx.profile?.RESOURCING ||
                        _ctx.currentUserIsAssigned) &&
                    _ctx.amendsFormData?.currentStageName !== 'amend.notifyH2RUpdateAmend' &&
                    _ctx.amendsFormData?.currentStageName !== 'amend.complete')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 10,
                        class: "w-full mt-2 text-center px-4 py-2 rounded-md text-white bg-red-700 hover:bg-red-800 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[12] || (_cache[12] =
                            //@ts-ignore
                            (...args) => (_ctx.handleCancelAmend && _ctx.handleCancelAmend(...args)))
                    }, "\n          Cancel Amend\n        "))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                ((_ctx.currentUserIsDirectlyAssigned || _ctx.profile.H2R || _ctx.profile.ADMIN) &&
                    _ctx.amendsFormData?.currentStageName &&
                    ['amend.notifyBudgetApprover', 'amend.notifyHROps'].includes(_ctx.amendsFormData.currentStageName) &&
                    !_ctx.isDraft)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 11,
                        class: "mt-2 w-full text-center px-4 py-2 rounded-md text-white bg-red-700 hover:bg-red-800 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[13] || (_cache[13] =
                            //@ts-ignore
                            (...args) => (_ctx.openRejectModal && _ctx.openRejectModal(...args)))
                    }, "\n          Reject\n        "))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.amendsFormData?.currentStageName === 'amend.notifyBudgetApprover' ||
                    _ctx.amendsFormData?.currentStageName === 'amend.notifyHROps')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_27, "\n          * If you would like to request more info, scroll down and use the form\n          at the bottom of the page\n        "))
                    : _createCommentVNode("", true)
            ]),
            timeline: _withCtx(() => [
                (_ctx.amendsFormData?.activityList)
                    ? (_openBlock(), _createBlock(_component_activity_feed, {
                        key: 0,
                        "activity-list": _ctx.amendsFormData?.activityList
                    }, null, 8, ["activity-list"]))
                    : _createCommentVNode("", true)
            ]),
            footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_28, [
                    (_ctx.amendsFormData.activityList)
                        ? (_openBlock(), _createBlock(_component_approval_steps, {
                            key: 0,
                            "doc-type": "AMEND",
                            "form-data": _ctx.amendsFormData,
                            onComment: _cache[14] || (_cache[14] = ($event) => (_ctx.fetchSingleDocument(_ctx.amendsFormData?.docId)))
                        }, null, 8, ["form-data"]))
                        : _createCommentVNode("", true)
                ])
            ]),
            _: 1
        }, 8, ["nav-item-config", "current-nav-item", "form-point", "form-data", "display-header", "display-timeline", "display-footer", "print-mode", "onSetCurrentNavItem"]),
        _createTextVNode(),
        (_ctx.showRejectModal)
            ? (_openBlock(), _createBlock(_component_ModalWindow, {
                key: 0,
                onClose: _ctx.closeRejectModal
            }, {
                icon: _withCtx(() => [
                    _createVNode(_component_ExclamationIcon, {
                        class: "h-12 w-12 bg-white text-red-600",
                        "aria-hidden": "true"
                    })
                ]),
                title: _withCtx(() => [
                    _createTextVNode("Reject Amendment")
                ]),
                subtitle: _withCtx(() => [
                    _createTextVNode("Are you sure you want to reject this amendment? This action cannot be\n        undone.")
                ]),
                main: _withCtx(() => [
                    _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_31, [
                            _withDirectives(_createElementVNode("textarea", {
                                id: "about",
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.rejectionComment) = $event)),
                                name: "about",
                                rows: "3",
                                class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md"
                            }, null, 512), [
                                [_vModelText, _ctx.rejectionComment]
                            ])
                        ])
                    ])
                ]),
                footer: _withCtx(() => [
                    _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 my-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm",
                        onClick: _cache[16] || (_cache[16] =
                            //@ts-ignore
                            (...args) => (_ctx.handleRejectRequest && _ctx.handleRejectRequest(...args)))
                    }, "\n          Reject\n        "),
                    _createTextVNode(),
                    _createElementVNode("button", {
                        type: "button",
                        class: "mt-2 inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 my-2 bg-gray-200 hover:bg-gray-300 text-base font-medium text-gray-800 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm",
                        onClick: _cache[17] || (_cache[17] =
                            //@ts-ignore
                            (...args) => (_ctx.closeRejectModal && _ctx.closeRejectModal(...args)))
                    }, "\n          Cancel\n        ")
                ]),
                _: 1
            }, 8, ["onClose"]))
            : _createCommentVNode("", true),
        _createTextVNode(),
        (_ctx.showDeleteModal)
            ? (_openBlock(), _createBlock(_component_ModalWindow, {
                key: 1,
                onClose: _cache[20] || (_cache[20] = ($event) => (_ctx.showDeleteModal = false))
            }, {
                icon: _withCtx(() => [
                    _createVNode(_component_CheckIcon, {
                        class: "h-6 w-6 text-green-600",
                        "aria-hidden": "true"
                    })
                ]),
                title: _withCtx(() => [
                    _createTextVNode("Delete Draft")
                ]),
                subtitle: _withCtx(() => [
                    _createTextVNode("Are you sure you want to delete this draft?")
                ]),
                footer: _withCtx(() => [
                    _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 my-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm",
                        onClick: _cache[18] || (_cache[18] =
                            //@ts-ignore
                            (...args) => (_ctx.handleDeleteDraft && _ctx.handleDeleteDraft(...args)))
                    }, "\n          Delete\n        "),
                    _createTextVNode(),
                    _createElementVNode("button", {
                        class: "w-full text-center mt-2 px-4 py-2 rounded-md text-white bg-red-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat",
                        onClick: _cache[19] || (_cache[19] = ($event) => (_ctx.showDeleteModal = false))
                    }, "\n          Cancel\n        ")
                ]),
                _: 1
            }))
            : _createCommentVNode("", true),
        _createTextVNode(),
        (_ctx.showSendAmendLetterModal &&
            _ctx.amendsFormData?.docId &&
            _ctx.amendsFormData?.requestedBy)
            ? (_openBlock(), _createBlock(_component_ModalWindow, {
                key: 2,
                size: "3xl",
                onClose: _cache[22] || (_cache[22] = ($event) => (_ctx.showSendAmendLetterModal = false))
            }, {
                icon: _withCtx(() => [
                    _createVNode(_component_MailIcon, {
                        class: "h-6 w-6 text-green-600",
                        "aria-hidden": "true"
                    })
                ]),
                title: _withCtx(() => [
                    _createTextVNode("Send letter")
                ]),
                subtitle: _withCtx(() => [
                    _createTextVNode("\n        Upload a PDF amendment letter. It is emailed to the person who completed\n        the form, with a covering email, and retained on this request.\n      ")
                ]),
                main: _withCtx(() => [
                    _createVNode(_component_SendAmendLetterUpload, {
                        "doc-id": _ctx.amendsFormData.docId,
                        "doc-owner": _ctx.amendsFormData.requestedBy,
                        "short-id": _ctx.amendsFormData.shortId,
                        "recipient-email": _ctx.amendsFormData.formOne?.email || null,
                        "hiring-manager-name": _ctx.amendsFormData.formOne?.name || '',
                        "employee-full-name": _ctx.amendsFormData.formTwo?.employeeName || '',
                        "administrator-name": _ctx.amendAdministratorName,
                        onSent: _ctx.handleAmendLetterSent
                    }, null, 8, ["doc-id", "doc-owner", "short-id", "recipient-email", "hiring-manager-name", "employee-full-name", "administrator-name", "onSent"])
                ]),
                footer: _withCtx(() => [
                    _createElementVNode("button", {
                        type: "button",
                        class: "w-full text-center mt-2 px-4 py-2 rounded-md text-white bg-red-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500",
                        onClick: _cache[21] || (_cache[21] = ($event) => (_ctx.showSendAmendLetterModal = false))
                    }, "\n          Cancel\n        ")
                ]),
                _: 1
            }))
            : _createCommentVNode("", true)
    ]));
}
